import { apiClient } from "./api-client";
import type { ContributionsStatsResponse, EarningsStatsResponse } from "@/lib/types/stats";
import { parsePlatformStats } from "./platform-stats.contract";

export const statsApi = {
  async getContributions(params?: { from?: string; to?: string; language?: string }) {
    const { data } = await apiClient.get<ContributionsStatsResponse>("/stats/contributions", {
      params,
    });
    return data;
  },

  async getEarnings(params?: { from?: string; to?: string; language?: string }) {
    const { data } = await apiClient.get<EarningsStatsResponse>("/stats/earnings", {
      params,
    });
    return data;
  },

  /** Public home page numbers, no auth needed. Checked before use. */
  async getPlatform() {
    const { data } = await apiClient.get<unknown>("/stats/platform");
    return parsePlatformStats(data);
  },
};
